import { render, staticRenderFns } from "./CategoryLevel1.vue?vue&type=template&id=d4880bda&"
import script from "./CategoryLevel1.vue?vue&type=script&lang=js&"
export * from "./CategoryLevel1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports